import { render, staticRenderFns } from "./bank-question-list-item.vue?vue&type=template&id=acbffe56"
import script from "./bank-question-list-item.vue?vue&type=script&lang=js"
export * from "./bank-question-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports